<template>
  <c-view>
    <c-page class="share-container">
      <c-navbar title="邀请好友，积累基金"></c-navbar>
      <c-content>
        <div class="share-box">
          <div class="price">
            <span>￥</span>
            <span class="price-number">
              {{totalAmount | currencyNormal}}
            </span>
          </div>
          <div class="text-center desc">当前生意基金 <br>（活动期间可直接抵扣）</div>
          <div class="split-line"></div>
          <div class="share-desc">
            <div class="text-center bold share-desc-title">生意基金积累规则</div>
            <div class="mt-20 bold">5.7~5.17预热活动期间：积累</div>
            <div>
              5.7~5.17预热活动期间每有一个好友通过您分享注册成功，您可获得<span class="text-brown">5元</span>生意基金（最多可积累<span class="text-brown">200元</span>）。
            </div>
            <div class="mt-10 bold">
              5.18~5.22正式活动期间：使用
            </div>
            <div>购买活动商品时，可使用您已积累的生意基金直接抵扣。</div>
          </div>
        </div>
        <div class="share-panel">
          <div class="share-line"><span class="bg-color white">分享链接</span></div>
          <div class="share-item">
            <div v-for="item in shareItem" @click="shareTo(item.method)">
              <div class="pl-20 pr-20">
                <img class="share-icon" :src="item.icon" alt="">
                <div class="pt-10 share-name text-center">{{item.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import api from '@/tools/api-tools'
  import ItemData from '../../../../model/laoban'

  export default {
    data () {
      const itemData = new ItemData()
      return {
        itemData,
        shareItem: [],
        shareConfig: {},
        params: {
          info: 'recommendinfo' // 推荐信息，金额
        },
        totalAmount: 0,
        shortUrl: ''
      }
    },
    components: {},
    created () {
    },
    async mounted () {
      await this.getUrl()
      this.getPrice()
      this.getImages()
    },
    beforeDestroy () {
    },
    methods: {
      // 获取分享短链接
      async getUrl () {
        this.shortUrl = await this.itemData.getShortUrl()
      },
      // 获取累计金额
      getPrice () {
        this.itemData.saveCoupon(this.params.info).then(res => {
          this.totalAmount = res.data.totalAmount
        })
      },
      // 获取图片资源
      getImages () {
        return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/realsale/share/config`).then(res => {
          this.shareItem = res.data.shareItem
          this.shareConfig = res.data.shareConfig
          console.log('shareConfig', this.shortUrl)
          this.shareConfig.link = `${this.shareConfig.link}` + encodeURIComponent(this.shortUrl)
          console.log(this.shareConfig.link)
        })
      },
      // 分享
      shareTo (shareType) {
        if (window.localStorage && window.localStorage.getItem('version') !== '3.1.44') {
          this.$wejs.alert('请升级APP', function () {
            window.location.href = 'http://itunes.apple.com/cn/app/id881836296?mt=8'
          })
          return
        }
        window.$fe_bridge.shareAction[shareType](this.shareConfig, function () {
          console.log('have share')
        })
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?2f77a830